import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material';

import { SharedModule } from '../shared/shared.module';
import { UsersRoutingModule } from './users-routing.module';
import { UsersComponent } from './users/users.component';
import { UserEditModalComponent } from './user-edit-modal/user-edit-modal.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    UsersRoutingModule,
    MatDialogModule,
  ],
  entryComponents: [UserEditModalComponent],
  declarations: [UsersComponent, UserEditModalComponent],
})
export class UsersModule { }
